import {Injectable} from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import {AuthenticationService} from '../_services';
import {environment} from '../../environments/environment';
import {AccountService} from '../_services/account.service';
import { retryWithBackoff } from '../_operators/retryWithBackoff';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService,
              private accountService: AccountService) {
  }

  logout() {
    this.authenticationService.logout().subscribe(() => {
      this.authenticationService.clearSession();
      this.accountService.destroyUserSession();
      location.reload();
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retryWithBackoff(1000),
      catchError((err) => {
      if (err.status === 401) {
        const tokenExpired = err.headers.get('Token-Expired') === 'true';
        if (tokenExpired) {
          const params = {
            token: this.authenticationService.currentUserValue.token,
            refreshToken: this.authenticationService.currentUserValue.refresh || this.authenticationService.currentUserValue['refreshToken']
          };
          return this.http.post(`${environment.apiUrl}/api/jwt/refresh`, params)
            .pipe(catchError((error1) => {
              this.logout();
              return throwError(err);
            }))
            .pipe(mergeMap((data) => {
              // if (data['token'] && data['refreshToken']) {
              if (data['token']) {
                const refreshToken = jwt_decode(data['token'])['refreshToken'];
                this.authenticationService.setActiveToken(data['token'], refreshToken, '');
                request = request.clone({
                  setHeaders: {
                    'Authorization': `Bearer ${data['token']}`
                  }
                });
                return next.handle(request);
              } else {
                this.logout();
              }
            }));
        } else {
          this.logout();
        }

      }

      const error = err.message || err.statusText;
      return throwError(err);
    }));
  }
}
